export default {
  "site_name": "Kakobuy Courses",
  "site_tagline": "Najlepszy Arkusz Zakupowy",
  "nav_home": "Strona główna",
  "nav_blog": "Blog",
  "nav_categories": "Kategorie",
  "nav_shopping_guide": "Poradnik zakupowy",
  "btn_spreadsheet": "kakobuy spreadsheet",
  "btn_buy_now": "buy it now",
  "btn_learn_more": "Dowiedz się więcej",
  "btn_read_article": "Czytaj artykuł",
  "btn_back_home": "Powrót na stronę główną",
  "breadcrumb_home": "Strona główna",
  "breadcrumb_blog": "Blog",
  "form_email_placeholder": "Twój adres email",
  "form_subscribe": "Zapisz się",
  "form_subscribe_text": "Zapisz się do newslettera, aby otrzymywać najnowsze aktualizacje",
  "footer_rights": "Wszelkie prawa zastrzeżone.",
  "footer_privacy": "Polityka prywatności",
  "footer_terms": "Warunki korzystania",
  "footer_contact": "Kontakt",
  "loading": "Ładowanie...",
  "error": "Wystąpił błąd",
}